import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AppStrings from '../config/appstring';
import { handleExport } from '../utils/exportUtils';
import ExportSelect from '../Class/ExportType';
import ClassSelect from '../Class/ClassSelect';
import SectionSelect from '../Class/Section';

const StudentPromotionList = ({user}) => {
  const [data, setData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [feeDetails, setFeeDetails] = useState([]);
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
const [exportFormat, setExportFormat] = useState('');
const [formData, setFormData] = useState({ CLASS1: '' ,SECTION1:'',ADDFEES1:'',CLASS2: '' ,SECTION2:'',ADDFEES2:'',SHIFT:''});
const [feeDetailsMap, setFeeDetailsMap] = useState({});

  useEffect(() => {
   
console.log("Logged in as:", user?.name);
    //fetchStudentData();
  }, [user]);

  const fetchStudentData = async () => {
    try {
       // console.log(formData.SHIFT ,"11111111111111kkkkkkkkkkkkkkjjjjjjjjjjjjjjjjj");
      const { CLASS1, SECTION1, ADDFEES1 } = formData;
  
      // If any of these are required, add validation
      if (!CLASS1  || !ADDFEES1) {
        alert("Please select class, section and fee type.");
        return;
      }

      setError('Loading...');
  console.log(CLASS1, SECTION1, ADDFEES1);
 // console.log(AppStrings.StudentPromotionList+`?TYPE=${ADDFEES1}&CLASS=${CLASS1}&SECTION=${SECTION1}`,'llllllllllllll');
      const response = await axios.get(AppStrings.StudentPromotionList+`?TYPE=${ADDFEES1}&CLASS=${CLASS1}&SECTION=${SECTION1}`, {
        params: {
          CLASS1,
          SECTION1,
          FEESTYPE: ADDFEES1,
        }
      });

      console.log("kkkkkkkkkkkkkkjjjjjjjjjjjjjjjjj");
  
      const result = response.data.data.result || response.data.data;
  
      if (Array.isArray(result)) {
        setData(result);
        setError('');

      //  setFeeDetailsMap(result);
      //  console.log(feeDetailsMap,'details.....');

      } else {
        setError('Unexpected response format');
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

   const StudentDataGet = async () => {
     console.log(formData.SHIFT ,"11111111111111kkkkkkkkkkkkkkjjjjjjjjjjjjjjjjj");
    if(formData.SHIFT=="UT")
      {
TransfetchStudentData();
      }
      else
      {
fetchStudentData();
      }
    
   }



  const TransfetchStudentData = async () => {
    try {
      
      const { CLASS1, SECTION1, ADDFEES1 } = formData;
  
      // If any of these are required, add validation
      if (!CLASS1  || !ADDFEES1) {
        alert("Please select class, section and fee type.");
        return;
      }
  console.log(CLASS1, SECTION1, ADDFEES1);
 // console.log(AppStrings.StudentPromotionList+`?TYPE=${ADDFEES1}&CLASS=${CLASS1}&SECTION=${SECTION1}`,'llllllllllllll');
      const response = await axios.get(AppStrings.ReTransforStudent+`?TYPE=${ADDFEES1}&CLASS=${CLASS1}&SECTION=${SECTION1}`, {
        params: {
          CLASS1,
          SECTION1,
          FEESTYPE: ADDFEES1,
        }
      });

      console.log("kkkkkkkkkkkkkkjjjjjjjjjjjjjjjjj");
  
      const result = response.data.data.result || response.data.data;
  
      if (Array.isArray(result)) {
        setData(result);
        setError('');

      //  setFeeDetailsMap(result);
      //  console.log(feeDetailsMap,'details.....');

      } else {
        setError('Unexpected response format');
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel = () => {
    setSelectedRow(null);
    setFeeDetails([]);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);


  //  const [firstName, setFirstName] = useState("");
  //       const [lastName, setLastName] = useState("");
        
  const handleSubmit = async () => {
    const studentsToSubmit = data.filter((student) =>
      selectedStudents.includes(student.STUDENT_ID)
    );
  
    const payload = studentsToSubmit.map((student) => ({
      student: {
        id: student.STUDENT_ID,
        admissionDate,
        class: formData.CLASS2, 
        section:formData.SECTION2,
        addfees:formData.ADDFEES2,
        type:formData.SHIFT,
        username:user?.name
      } // or remove this key entirely if not needed
    }));

    
  
    if (payload.length === 0 ) {
      alert("No valid student fee data to submit.");
      return;
    }
  
    try {

    console.log(payload,'zzzzzzz')
    setError('Loading...');
      const res = await fetch(AppStrings.StudentPromotionEntry, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        
      });
  
      const result = await res.json();
      setError('');

      setSelectedStudents([]);

/* OPTIONAL */
setSelectedRow(null);
      StudentDataGet();
      alert(result.message || "Data saved successfully!");
      
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to save data.");
    }
  };
  
  
    const handleChange = (e) => {
        const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
      };

  const handleExportClick = () => {
      handleExport(data, exportFormat, 'Student_Promotion');
    };

    
  const handleCheckboxChange = (studentId) => {
    setSelectedStudents((prev) =>
      prev.includes(studentId)
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId]
    );
  };

   const handleShiftChange = (e) => {
    const selectedShift = e.target.value;
    setFormData(prev => ({
      ...prev,
      SHIFT: selectedShift,
    }));
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allIds = data
        .filter((row) =>
          row.NAME.toLowerCase().includes(search.toLowerCase()) ||
          row.STUDENT_ID.toLowerCase().includes(search.toLowerCase())
        )
        .map((row) => row.STUDENT_ID);
      setSelectedStudents(allIds);
    } else {
      setSelectedStudents([]);
    }
  };

  

  return (
    <div style={{ padding: '0px' }}>
      <div style={HeaderTitle}>Student Promotion List</div>

      {/* {loading && <p>Loading data...</p>} */}
      {error && <p style={{ color: 'red' }}>{error}</p>}


      {/* <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <input
              type="text"
              placeholder="Search By Student Name/Student Id"
              name="STUDENTNAME"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoComplete="off"
              className="input"
            />
            <br />
          </div>
        </div>
        <div className="col-75">
        
          
        <div className="row">
        <div className="col-25 colM">
        <ExportSelect
      value={exportFormat} // Controlled value for the select dropdown
      onChange={(e) => setExportFormat(e.target.value)} // Handle change to update formData
    />
    
    </div>
    <div className="col-75 colM ">
    <button className='GridButton' onClick={handleExportClick} disabled={!exportFormat}>
  Export
</button>
    
    </div>
    </div>
      </div>
      </div> */}
<div className="row">
        <div className="col-25">
        <div className="row">
        <div className="col-251 colM">

        <label style={{ ...radioBtnStyle, borderColor: '#a2dff5' }}>
              <input
                type="radio"
                name="SHIFT"
                value="G"
                checked={formData.SHIFT === "G"}
                onChange={handleShiftChange}
              />
              Group Change
            </label>
    </div>
    <div className="col-751 colM ">
    {/* <label style={{ ...radioBtnStyle, borderColor: '#cb8cf5' }}>
              <input
                type="radio"
                name="SHIFT"
                value="P"
                checked={formData.SHIFT === "P"}
                onChange={handleShiftChange}
              />
              Promotion
            </label> */}
    </div>
    <div className="col-251 colM">


    <div class="coolinput">
        <label style={{ ...radioBtnStyle, borderColor: '#d27811ff' }}>
              <input
                type="radio"
                name="SHIFT"
                value="T"
                checked={formData.SHIFT === "T"}
               onChange={handleShiftChange}
              />
             Transfer
            </label>
    </div>
    

</div>
<div className="col-751 colM ">
    <div class="coolinput">
        <label style={{ ...radioBtnStyle, borderColor: '#fb48c2ff' }}>
              <input
                type="radio"
                name="SHIFT"
                value="UT"
                checked={formData.SHIFT === "UT"}
               onChange={handleShiftChange}
              />
             Re-Active
            </label>
    </div>
</div>
<div className="col-751 colM ">
    <div class="coolinput">
        <label style={{ ...radioBtnStyle, borderColor: 'rgb(40, 18, 185)' }}>
              <input
                type="radio"
                name="SHIFT"
                value="YP"
                checked={formData.SHIFT === "YP"}
               onChange={handleShiftChange}
              />
             Year Pass
            </label>
    </div>
</div>
{/* <div className="col-751 colM ">
    <div class="coolinput">
        <label style={{ ...radioBtnStyle, borderColor: '#a50971ff' }}>
              <input
                type="radio"
                name="SHIFT"
                value="T"
                checked={formData.SHIFT === "T"}
               onChange={handleShiftChange}
              />
             De-Active
            </label>
    </div>
</div> */}
    </div>
        </div>
        <div className="col-75">
       
        <div className="row">
<div className="coolinput">
            <input
              type="text"
              placeholder="Search By Student Name/Student Id"
              name="STUDENTNAME"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoComplete="off"
              className="input"
            />
            <br />
          </div>
    </div>
      </div>
      </div>
      

      <div className="row">
        <div className="col-25">
        <div className="row">
        <div className="col-251 colM">

        <ClassSelect
        value={formData.CLASS1} // Controlled value for the select dropdown
        onChange={(e) => setFormData({ ...formData, CLASS1: e.target.value })}// Handle change to update formData
      />
    
    </div>
    <div className="col-751 colM ">
     <SectionSelect
        value={formData.SECTION1} // Controlled value for the select dropdown
        onChange={(e) => setFormData({ ...formData, SECTION1: e.target.value })} // Handle change to update formData
      />
    
    </div>
    <div className="col-251 colM">


    <div class="coolinput">
      <label for="input" class="text">Admission:</label>
    <select type="text" placeholder="" name="ADDFEES1"   value={formData.ADDFEES1}
  onChange={handleChange}  autoComplete="off" class="input">
    <option value="">SELECT</option>
    <option value="MET">METIRC</option>
    <option value="CBSE">CBSE</option>
    <option value="RTE">RTE</option>
     <option value="SCIRT">SCIRTE</option>
    </select>
    </div>

</div>
<div className="col-751 colM ">
    <br/>
<button className='GridButton' onClick={StudentDataGet} >
  View
</button>

</div>
    </div>
        </div>
        <div className="col-75">
       
        <div className="row">
        <div className="col-251 colM">

        <ClassSelect
        value={formData.CLASS2} // Controlled value for the select dropdown
        onChange={(e) => setFormData({ ...formData, CLASS2: e.target.value })} // Handle change to update formData
      />
    
    </div>
    <div className="col-751 colM ">
     <SectionSelect
        value={formData.SECTION2} // Controlled value for the select dropdown
        onChange={(e) => setFormData({ ...formData, SECTION2: e.target.value })}  // Handle change to update formData
      />
    
    </div>
    <div className="col-251 colM">


    <div class="coolinput">
      <label for="input" class="text">Admission:</label>
    <select type="text" placeholder="" name="ADDFEES2"   value={formData.ADDFEES2}
  onChange={handleChange}  autoComplete="off" class="input">
    <option value="">SELECT</option>
    <option value="MET">METIRC</option>
    <option value="CBSE">CBSE</option>
    <option value="RTE">RTE</option>
     <option value="SCIRT">SCIRTE</option>
    </select>
    </div>

</div>
<div className="col-751 colM ">
    <br/>
<button className='GridButton PromotionBtn' onClick={handleSubmit}>
  Go...
</button>

</div>
    </div>
      </div>
      </div>

      {!loading && !error && Array.isArray(data) && (
        <div style={{ maxHeight: '440px', overflowY: 'auto', border: '1px solid #ccc' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ ...headerCellStyle, width: '100px' }}>Student ID</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Name</th>
            
                <th style={{ ...headerCellStyle, width: '100px' }}>Class</th>
              
                <th style={{ ...headerCellStyle, width: '100px' }}>Tuition Due</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Transport Due</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>
                  <input
                    type="checkbox"
                    checked={selectedStudents.length === data.filter((row) =>
                      row.NAME.toLowerCase().includes(search.toLowerCase()) ||
                      row.STUDENT_ID.toLowerCase().includes(search.toLowerCase())
                    ).length}
                    onChange={handleSelectAllChange}
                  />
                </th>
                {/* <th style={{ ...headerCellStyle, width: '120px' }}>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {data
                .filter((row) =>
                  row.NAME.toLowerCase().includes(search.toLowerCase()) ||
                  row.STUDENT_ID.toLowerCase().includes(search.toLowerCase())
                )
                .map((row, index) => (
                  <tr key={index}>
                    <td style={cellStyle}>{row.STUDENT_ID}</td>
                    <td style={cellStyle}>{row.NAME}</td>
            
                    <td style={cellStyle}>{row.CLASS_SEC}</td>
                
                    <td style={cellStyle}>{row.ACADEMIC_DUE}</td>
                    <td style={cellStyle}>{row.TRANSPORT_DUE}</td>
                    <td style={{ ...cellStyle, textAlign: 'center', verticalAlign: 'middle' }}>
                      <input
                        type="checkbox"
                        checked={selectedStudents.includes(row.STUDENT_ID)}
                        onChange={() => handleCheckboxChange(row.STUDENT_ID)}
                      />
                    </td>
                    {/* <td style={cellStyle}>
                      <button className="GridButton" onClick={() => handlePayClick(row)}>Pay</button>
                      <button className="GridButton" onClick={handleCancel}>Cancel</button>
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// Styles

const radioBtnStyle = {
  marginRight: '10px',
   padding: '5px 10px',           // Optional: space inside the label
  border: '3px solid',      // Optional: visible border
  borderRadius: '8px',           // 🔹 Rounded corners
  display: 'inline-block',       // Ensures label wraps content properly
  cursor: 'pointer' ,width:'80%'
};

const HeaderTitle={
 fontSize: '20px',
  fontWeight: 'bold',
}


const headerCellStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

const cellStyle = {
  border: '1px solid #ddd',
padding: '2px',
  fontSize:'13px'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '700px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  textAlign: 'center',
};

export default StudentPromotionList;
